export enum SpecialCaseThemeName {
  Story = 'STORY',
}
